import { IExamData, IExamResult, IExerciseResult, QuestionCheckItem } from '@/interface'
// import { IPageData } from '~/typings'
import { getExamInfo, getExamResult, QuizQuery, getExamQualify, getExamAnalysis, QUESTION_TYPES } from '@/request/api/exam'
// import { getBannerInfo } from '@/request/api/common'
import { Commit } from 'vuex'
import { QUSTION_NO } from '@/utils/moduleHooks/exam'

const state = {
  examInfo: {} as IExamData,
  examAnalysis: {} as IExamData,
  // 考试结果状态，增加一个ifStatusChecked来标记是否已查询，避免组件提前请求getContent
  examResult: {} as IExamResult & { ifStatusChecked?: boolean },
  // 用户是否正在考试, 用户提交考试后修改这个值的状态
  ifUserInExam: true,
  entryStatus: null as string | null,
  exerciseResult: {} as IExerciseResult // 实操练习结果
}

export type examState = typeof state

const examStore = {
  namespaced: true,
  state,
  actions: {
    // 获取考试内容
    async getExamInfo ({ commit }: { commit: Commit }, payload: QuizQuery) {
      const res = await getExamInfo(payload)
      const data = (res?.data || {}) as IExamData
      commit('setExamInfo', data)
    },
    // 获取答题解析
    async getExamAnalysis ({ commit }: { commit: Commit }, payload: {
      examRefId: string
      examRecordsId: string
    }) {
      const res = await getExamAnalysis(payload)
      const data = (res?.data || {}) as IExamData
      commit('setExamAnalysis', data)
    },
    async queryExamStatus ({ commit }: { commit: Commit }, payload: QuizQuery) {
      const res = await getExamResult(payload)
      const data = (res?.data || {}) as IExamResult
      const theoryExamScore = data.theoryExamScore || payload.score
      const examRecordsId = payload.examRecordsId
      commit('setExamResult', {
        ...data,
        theoryExamScore,
        examRecordsId
      })
    },
    async getExamQualify ({ commit }: { commit: Commit }, payload: QuizQuery) {
      const res = await getExamQualify(payload)
      commit('setEntryStatus', (res?.data as { entryStatus: string })?.entryStatus || '0')
    }
  },
  mutations: {
    setExamInfo (state: examState, data: IExamData): void {
      if (data.questionHisList) {
        // 增加一个checkedId保存用户选择的option
        data.questionHisList.map(i => ({ ...i, checkedId: null }))
      }
      state.examInfo = data
      state.ifUserInExam = true
    },
    setExamAnalysis (state: examState, data: IExamData): void {
      if (data.questionHisCheckList) {
        data.questionHisCheckList
          .forEach(i => {
            if (parseInt(i.questionType) === QUESTION_TYPES.multi) {
              i.answer = i.answer ? JSON.parse(i.answer).join(',') : '-'
              i.userAnswer = i.userAnswer ? JSON.parse(i.userAnswer).join(',') : '-'
            }
          })
      }
      const questionHisCheckList = [] as QuestionCheckItem[]
      // 处理题目乱序/选项乱序的情况
      state.examInfo.questionHisList.forEach(item => {
        // 根据questionRefId匹配到对应题目
        const answerItem = data.questionHisCheckList.find(q => q.questionRefId === item.questionRefId) || {} as QuestionCheckItem
        // 筛选正确答案，从原始题目中找到对应optionNo的index，然后根据这个index修改answer
        if (parseInt(answerItem.questionType) !== QUESTION_TYPES.multi) {
          // 单选
          const correctAnswer = answerItem.answer
          const answerIndex = item.hisOptionList.findIndex(option => option.optionNo === correctAnswer)
          const yourIndex = item.hisOptionList.findIndex(option => option.optionNo === item.checkedId)
          answerItem.answer = QUSTION_NO[answerIndex] || '-'
          answerItem.userAnswer = QUSTION_NO[yourIndex] || '-'
        } else {
          // 多选
          const answers = answerItem.answer.split(',') || []
          const correctAnswers = [] as string[]
          const yourAnswers = [] as string[]
          answers.forEach(an => {
            const index = item.hisOptionList.findIndex(option => option.optionNo === an)
            correctAnswers.push(QUSTION_NO[index])
          })
          if (Array.isArray(item.checkedId)) {
            item.checkedId.forEach(an => {
              const index = item.hisOptionList.findIndex(option => option.optionNo === an)
              yourAnswers.push(QUSTION_NO[index])
            })
          }
          answerItem.answer = correctAnswers.sort((prev, next) => prev > next ? 1 : -1).join(',') || '-'
          answerItem.userAnswer = yourAnswers.sort((prev, next) => prev > next ? 1 : -1).join(',') || '-'
        }
        questionHisCheckList.push(answerItem)
      })
      // console.log('ON_setExamAnalysis', questionHisCheckList, state.examInfo.questionHisList)
      state.examInfo = {
        ...state.examInfo,
        questionHisCheckList: questionHisCheckList
      }
    },
    setExamResult (state: examState, data: IExamResult): void {
      state.examResult = { ...data, ifStatusChecked: true }
    },
    setIfUserInExam (state: examState, bool: boolean): void {
      state.ifUserInExam = bool
    },
    setEntryStatus (state: examState, value: string) {
      state.entryStatus = value
    },
    // 初始化状态，在其他地方也可能请求一些考试信息，用户进入考试页面后，应该初始化状态，避免信息污染
    initExamStoreData (state: examState) {
      state.entryStatus = null
      state.examInfo = {} as IExamData
      state.examResult = {} as IExamResult
      state.ifUserInExam = true
    },
    setExerciseResult (state: examState, data: IExerciseResult) {
      state.exerciseResult = data
    }
  }
}

export {
  examStore
}
